import React, { useState } from 'react'
import './SubscribeForm.css'

// Icons
import { AiFillFire } from "react-icons/ai";
import { LuUtilityPole } from "react-icons/lu";
import { BsThreeDots } from "react-icons/bs";

const SubscribeForm = () => {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [error, setError] = useState('')
    const [selectIndustryPopup, setSelectIndustryPopup] = useState(false);

    const openIndustryPopup = (e: React.FormEvent) => {
        e.preventDefault();
        setSelectIndustryPopup(true);
    };

    const fetchCsrfToken = async () => {
        const response = await fetch('/api/csrf-token/', {
            method: 'GET',
            credentials: "same-origin", // include cookies in the request
        });

        if (response.ok) {
            const data = await response.json();
            return data.csrfToken; // Return the CSRF token
        } else {
            console.error('Failed to fetch CSRF token');
            return null;
        }
    };


    const subscribeWithIndustry = async (industry: string) => {

        const csrfToken = await fetchCsrfToken();
        if (!csrfToken) return;

        try {
            const response = await fetch('/api/subscribe/', {
                method: 'POST',
                credentials: "same-origin",
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                },
                body: JSON.stringify({ email, industry }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Subscription failed');
            }

            setSelectIndustryPopup(false);
            setSubmitted(true);
            setError('');
            setEmail('');

            setTimeout(() => setSubmitted(false), 6000);

        } catch (err: any) {
            console.error(err);
            setError(err.message || 'Something went wrong.');
        }
    };


    return (
        <div className="subscribe-wrapper">
            {submitted ? (
                <div className="thank-you-message">
                    <h1>Thank you for subscribing!</h1>
                </div>
            ) : (
                <form onSubmit={openIndustryPopup} className="my-sub-form">

                    <div className='blog-mini-div'>
                        <h1>
                            The storm moves fast. We move faster.
                            Get updates on the future of detection.
                        </h1>
                    </div>

                    <div className="sub-form-items-and-text">
                        <div className="sub-form-items">
                            <div className="sub-form-block">
                                <input
                                    className="subs-input"
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <button
                                className="subs-submit-button"
                                type="submit"
                            >
                                Send
                            </button>
                        </div>

                        <p>
                            Sign up for monthly updates on our progress,
                            partnerships, and the evolution of
                            High-Risk-Lightning™ detection.
                        </p>
                    </div>

                    {error && <p className="error-message">{error}</p>}
                </form>
            )}

            {/* Add Server Popup */}
            {selectIndustryPopup && (
                <div className='add-item-popup-overlay'>
                    <div className='add-item-popup-content hh-del-pop'>
                        <div className='hh-delete-inner-pop' style={{ gap: '2rem' }}>
                            <div className='hh-delete-text-and-icon'>

                                <div className='subscribe-industry-outer'>
                                    <h1>Which Industry Are You a Part of?</h1><br />

                                    <div className='subscribe-industry-selection'>

                                        <div className='subscribe-industry' onClick={() => subscribeWithIndustry('wildfire')}>
                                            <AiFillFire className="si-icon" />
                                            <h2>Wildfire</h2>
                                        </div>

                                        <div className='subscribe-industry' onClick={() => subscribeWithIndustry('utility')}>
                                            <LuUtilityPole className="si-icon" />
                                            <h2>Utility</h2>
                                        </div>

                                        <div className='subscribe-industry' onClick={() => subscribeWithIndustry('other')}>
                                            <BsThreeDots className="si-icon" />
                                            <h2>Other</h2>
                                        </div>


                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default SubscribeForm
